import { render, staticRenderFns } from "./ContactRoommateDialog.vue?vue&type=template&id=498e8f02&"
import script from "./ContactRoommateDialog.vue?vue&type=script&lang=js&"
export * from "./ContactRoommateDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactRoommateDialog.vue?vue&type=style&index=0&id=498e8f02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports